// Internal
import { getCheckoutSessionFlags } from '../globals';

type IntegrationType = 'EC:LEGACY' | 'EC:SPB' | 'WPS';

const getIntegrationType = (): IntegrationType => {
  const { isWPS } = getCheckoutSessionFlags();
  // `xprops` only exist on the SPB integration
  const isSPB = window.hasOwnProperty('xprops');

  if (isWPS) {
    return 'WPS';
  }
  if (isSPB) {
    return 'EC:SPB';
  }
  // `EC:LEGACY` means any EC flow that's not EC SPB.
  return 'EC:LEGACY';
};

export { getIntegrationType };
